import React from 'react'

export default function Regent() {
    return (
        <section className="small-section">
            <h1>Mini Regent Pattern</h1>
            <img className="pattern-assembly-image" src="/images/patterns/regent/regent.jpg" alt="regent"></img>
            <h3>Materials</h3>
            <p>
                <ul>
                    <li>Blue (navy/royal) yarn</li>
                    <li>Orange yarn</li>
                    <li>Light Orange yarn</li>
                    <li>Brown yarn</li>
                    <li>Gray yarn</li>
                    <li>Yellow yarn</li>
                </ul>
            </p>
            <h3>Abbreviations</h3>
            <ul>
                <li>sc = single crochet</li>
                <li>dc = double crochet</li>
                <li>inc = increase</li>
                <li>dec = decrease</li>
                <li>mr = magic ring</li>
                <li>blo = back loop only</li>
                <li>p = picot</li>
            </ul>
            <h3>Head</h3>
            <p>
                <b>(Create one in black and one in orange)</b> <br />
                Round 1: ch 3, 15 dc in mr, slst to the ch 3 (15) <br></br>
                Individual Star points <br />
                Row 2: 5 sc (5) <br></br>
                Row 3: dec, 3 sc (4) <br></br>
                Row 4: dec, 2 sc (3) <br></br>
                Row 5-6: 3 sc (3) <br></br>
                Row 7: dec, sc (2) <br></br>
                Row 8: 2 sc (2) <br></br>
                Row 9: dec (1) <br></br>
                Row 10: sc (1) <br></br>
                slst on the side of the point back to the base of the star, slst into the next stitch on the base of the star<br></br>
                <b>Repeat for 3 more points</b> <br></br>
            </p>
            <p>
                Now you should have one black and one orange 4 pointed stars. To connected them into the head, take the orange yarn,
                then sc around the edges. Make sure to stuff the points as you go.
                Once, the 2 sides are connected, do another round of sc
            </p>
            <h3>Body</h3>
            <p>
                <b>(In Orange)</b> <br></br>
                Round 1: 6 sc in mr(6)  <br></br>
                Round 2: 6 inc (12)  <br></br>
                Round 3: [1 sc, inc] * 6 (18)  <br></br>
                Round 4: [2 sc, inc] * 6 (24)  <br></br>
                Round 5: [3 sc, inc] * 6 (30)  <br></br>
                Round 6: [4 sc, inc] * 6 (36)  <br></br>
                Round 7-10: 1 sc around (36) (4 rounds) <br></br>
                <b>(Switch to Brown)</b> <br></br>
                Round 11-14: 1 sc around (36) (4 rounds) <br></br>
                Round 15: [4 sc, dec] * 6 (30)  <br></br>
                Round 16: [3 sc, dec] * 6 (24)  <br></br>
                Round 17: [2 sc, dec] * 6 (18)  <br></br>
                Round 18: [1 sc, dec] * 6 (12)  <br></br>
                Round 19: 6 dec (6)  <br></br>
                Fasten off, leave a tail for sewing
            </p>

            <h3>Legs (x2)</h3>
            <p>
                <b>(In Brown)</b> <br></br>
                Round 1: 6 sc in mr(6)  <br></br>
                Round 2: [1 sc, inc] * 6 (9)  <br></br>
                Round 3: 1 sc around blo (9) <br />
                Round 4-17: 1 sc around (9) (14 rounds) <br></br>
                Fasten off, leave a tail for sewing
            </p>
            <h3>Shoes (x2)</h3>
            <p>
                <b>(In Light Orange)</b> <br></br>
                Round 1: 6 sc in mr (6) <br />
                Round 2: 6 inc (12) <br />
                Round 3: 1 sc blo around (12) <br />
                Round 4-5: 1 sc around (12) (2 rounds) <br />
                Fasten off, leave a tail for sewing
            </p>

            <h3>Arms (x2)</h3>
            <p>
                <b>(In Orange)</b> <br></br>
                Round 1: 6 sc in mr(6)  <br></br>
                Round 2: [1 sc, inc] * 6 (9)  <br></br>
                Round 3-15: 1 sc around (9) (13 rounds) <br></br>
                Fasten off, leave a tail for sewing
            </p>
            <h3>Sleeves (x2)</h3>
            <p>
                <b>(In Blue)</b> <br></br>
                Round 1: 6 sc in mr (6) <br />
                Round 2: 6 inc (12) <br />
                Round 3: [2 sc, inc] * 4 (16) <br />
                Round 4-14: 1 sc around (16) (14 rounds) <br />
                Fasten off, leave a tail for sewing
            </p>

            <h3>Shirt</h3>
            <p>
                <b>(In Blue)</b> <br></br>
                The shirt is done in rows instead of rounds <br />
                Row 1: ch 51, slst in the first ch to make a ring, ch 1, turn (51) <br />
                Row 2-4: 51 sc, slst, ch 1, turn (51)<br />
                Row 5: [15 sc, dec] * 3 (48) <br />
                Row 6: [6 sc, dec] * 6 (42) <br />
                Row 7: [5 sc, dec] * 6 (36) <br />
                Row 8: [4 sc, dec] * 6 (30) <br />
                Row 9: [3 sc, dec] * 6 (24) <br />
                Now make 12 sc, ch 1, turn (mark this as the new starting point)
                Row 10-11: 24, ch 1, turn (24) <br />
                Row 12: dec, 20 sc, dec (22) <br />
                Row 13: [1 p, 1 sc] * 11 (22) <br />
                Fasten off
            </p>

            <h3>Shoulder Pads (x2)</h3>
            <p>
                <b>(In Light Orange)</b> <br></br>
                Round 1: 6 sc in mr (6) <br />
                Round 2: 1 sc around (6) <br />
                Round 3: [1 sc, inc] * 6 (9) <br />
                Round 4: [2 sc, inc] * 6 (12) <br />
                Fasten off the first one <br />
                Do not fasten off the second one, instead ch 12 and slst to connect to the first shoulder pad
            </p>

            <h2>Rock</h2>
            <h3>Top & Bottom Panel (x2)</h3>
            <p>
                <b>(In Gray)</b> <br></br>
                Row 1: ch 21, starting on second ch,20 sc (20) <br />
                Row 2-13: 21 sc, ch 1, turn (20) (16 rows)<br />
            </p>

            <h3>Left & Right Panel (x2)</h3>
            <p>
                <b>(In Gray)</b> <br></br>
                Row 1: ch 17, starting on second ch, 16 sc (16) <br />
                Row 2-8: 16 sc, ch 1, turn (16) (7 rows)<br />
            </p>

            <h3>Front & Back Panel (x2)</h3>
            <p>
                <b>(In Gray)</b> <br></br>
                Row 1: ch 21, starting on second ch, 20 sc (20) <br />
                Row 2-8: 20 sc, ch 1, turn (20) (7 rows)<br />
            </p>

            <h2>Assembly</h2>
            
            <h3>Putting Regent Together</h3>
            <p>
                <ol>
                    <li>Put the shoes on the legs and sew on the shoes</li>
                    <li>Put the arms in the sleeves and sew the sleeves to the arms</li>
                    <li>Sew the legs onto the body</li>
                    <li>Put the shirt on the body and sew just the bottom edge where the orange meets the brown</li>
                    <li>Sew the arms to the body</li>
                    <li>Sew the head onto the body (it should stick out of the whole where the shirt collar sticks up, and the black side faces the front)</li>
                    <li>Sew the shoulder pads on the shoulders and have the chain hang on the front of the collar</li>
                    <li>Take some yellow yarn and sew his eye onto his face</li>
                </ol>
            </p>

            <h3>Putting his rock together</h3>
            <p>
                <ol>
                    <li>Sew the left panel to the left of the top panel and the right panel to the right</li>
                    <li>Sew the front panel to the front of the top panel and the back panel to the back</li>
                    <li>Sew down the sides and edges</li>
                    <li>Sew the bottom panel in place (make sure to stuff before the rock is fully closed)</li>
                </ol>
            </p>
            
            <h3>Congrats on finishing!!! </h3>
            <p>
                Tag: @dango.ploof on insta to show me your Regent!!</p>

            <div className="patterns">
                <a href="/patterns">Back to Patterns</a>
            </div>
        </section>
    );
}